import {DatePattern} from '../types'

export const DATE_PATTERN: Record<DatePattern, string> = {
  first: 'd MMM yyyy',
  second: 'd MMM yy',
  third: 'd/MM/yy',
  fourth: 'MMM ‘yy',
  fifth: 'd MMM ‘yy',
  sixth: 'dd.MM.yyyy',
  seventh: 'd/MM',
  eight: 'MMMM yyyy',
  nineth: 'h:mm aaa d MMM',
  tenth: 'h:mm aaa',
  eleventh: 'MMM-yy',
  server: 'yyyy-MM-dd',
  serverSecond: 'yyyy-MM',
  pickerShort: 'ddMMy',
  pickerLong: 'dd MMMM y',
}

export const MIN_PICKER_DATE = new Date(2000, 0, 0)
